import { Outlet } from 'react-router-dom';
import Layout from '../components/Layout';
import useGlobalPollingErrorListener from '../hooks/useGlobalPollingErrorListener';

const AppLayout = () => {
  // Listen for global polling errors and display notifications
  useGlobalPollingErrorListener();

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default AppLayout;
